export default __webpack_public_path__ + "static/media/bg_main_contact.7d5b273a.png";